import Amplisky, { IGenericObject } from "@sky-it-livedata-libraries/amplisky";

let client: Amplisky | null = null;

export const getAmplisky = () => {
  if (client) {
    return client;
  }

  const config = getConfig();
  if (!config) {
    return;
  }

  if (typeof window === "undefined") {
    globalThis.WebSocket = class {} as any;
  }
  
  client = new Amplisky(config);
  return client;
};

function getConfig() {
  if (typeof window === "undefined") {
    return;
  }

  const settings = window.SkyFoundationSettings?.LIVEDATA_MOTORSPORTS_SCORES;
  if (!settings) {
    throw new Error("LIVEDATA_MOTORSPORTS_SCORES GraphQL Settings not found");
  }
  if (!settings.apikey) {
    throw new Error("LIVEDATA_MOTORSPORTS_SCORES GraphQL API key not found");
  }
  if (!settings.endpoint) {
    throw new Error("LIVEDATA_MOTORSPORTS_SCORES GraphQL endpoint not found");
  }
  if (!settings.realtimeEndpoint) {
    throw new Error("LIVEDATA_MOTORSPORTS_SCORES GraphQL realtime endpoint not found");
  }
  if (!settings.realtimeHost) {
    throw new Error("LIVEDATA_MOTORSPORTS_SCORES GraphQL realtime host not found");
  }

  return {
    apiKey: settings.apikey,
    endpoint: settings.endpoint,
    realtimeEndpoint: settings.realtimeEndpoint,
    realtimeHost: settings.realtimeHost,
    realtime: true,
  };
}

export type Variables = IGenericObject;
